import {
    Box,
    Flex,
}                           from "grid-styled"
import React, { Component } from "react"
import { connect }          from "react-redux"
import { NavLink }          from "react-router-dom"
import styled               from "styled-components"
import { Text }             from "../../../components/styled"
import { images }           from "../../../config/index"
import setLanguage          from "../../../infraMonitor/localization/actions"
import Icon                 from "../../Icon/Icon"
import { media }            from "../../styled/utils"
import { getMun } from "utils"

const municipality = getMun()

const en = {
    dashboard: "dashboard",
    projects: "projects",
    about: "about",
    contact: "contact",
    glossary: "Glossary",
    howToUse: "How to use?",
    downloads: "Downloads",
    localProjects: "Local projects",
}

const np = {
    dashboard: "ड्यासबोर्ड",
    projects: "परियोजनाहरू",
    about: "बारेमा",
    contact: "सम्पर्क गर्नुहोस्",
    glossary: "शब्दावली",
    howToUse: "कसरी प्रयोग गर्ने?",
    downloads: "डाउनलोडहरू",
    localProjects: "स्थानीय परियोजनाहरू",
}

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            darkTheme: true
        }
        this.handleTheme = this.handleTheme.bind(this)
    }

    setSelectedHelp = val => {
        this.props.setSelectedHelp(val)
    }

    openDownloadsModal = () => {
        this.props.openDownloadsModal()
    }

    toggleClass = (el, cls) => {
        document.querySelector(el).classList.toggle(cls)
    }

    componentDidMount() {
        if (window.localStorage && window.localStorage.getItem("darkTheme") === 'true') {
            document.querySelector('body').classList.remove('light-theme');
            this.setState({...this.state, darkTheme: true})
        } else {
            document.querySelector('body').classList.add('light-theme');
            this.setState({...this.state, darkTheme: false})
        }
    }

    handleTheme() {
        this.toggleClass('body', 'light-theme');
        this.setState({...this.state, darkTheme: !this.state.darkTheme})

        window.localStorage.darkTheme = !this.state.darkTheme;
    }

    render() {
        const {selectedLanguage} = this.props
        let localization = np

        if (selectedLanguage === "en") {
            localization = en
        }

        return (
            <div>
                <SidebarMain lang={selectedLanguage} className={'sidebar-main sidebar--mobile'}>
                    <div className="flex items-center justify-between px-4">
                        <Logo>
                            <NavLink to="/" className="logo-name">
                                <img src={images.appLogo} alt=""/>
                            </NavLink>
                        </Logo>
                        <div className="menu__help">
                            <div className="help-title flex items-center">
                                <Text.span className="help-text__icon"><img className="help-icon" height={18} width={18} src={images.icons.help} alt="help" /></Text.span>
                                <Text.span>Help</Text.span>
                            </div>
                            <div className="help-content">
                                <span className="caret"/>
                                <ul className="links">
                                    <li onClick={() => this.setSelectedHelp("glossary")}>
                                        <span>{localization.glossary}</span>
                                    </li>
                                    <li onClick={() => this.setSelectedHelp("howto")}>
                                        <span>{localization.howToUse}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="menu__switch">
                            <div className="localization-switch">
            <span
                className={selectedLanguage === "en" ? "active" : ""}
                onClick={() => {
                    this.props.dispatchLanguage("en")
                }}
            >
              en
            </span>
                                <span
                                    className={selectedLanguage === "np" ? "active" : ""}
                                    onClick={() => {
                                        this.props.dispatchLanguage("np")
                                    }}
                                >
              ने
            </span>
                            </div>
                        </div>
                        <div onClick={this.handleTheme}
                             className={'theme__switch flex cursor-pointer gap-2 items-center justify-center flex-col'}>
                        <span className={'text-white block text-center'}>
                        {this.state.darkTheme ? (selectedLanguage === 'np' ? ' अँध्यारो मोड' : 'Dark Mode') : (selectedLanguage === 'np' ? 'उज्यालो मोड' : 'Light Mode')}
                            </span>
                            <div
                                className={'theme-toggle relative'}>
                        <span className={'theme-toggle-el flex items-center justify-center'}>
                            <Icon name={'theme-toggler'}/>
                        </span>
                            </div>
                        </div>
                    </div>
                    <Flex className="menu">
                        <Box className="menu__dashboard">
                            <NavLink exact to="" activeClassName="active">
                                <Icon name={'dashboard'}/>
                                <span>{localization.dashboard}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__projects">
                            <NavLink to={"/projects"} activeClassName="active">
                                <Icon name={'projects'}/>
                                <span>{localization.projects}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__about">
                            <NavLink to="/about" activeClassName="active">
                                <Icon name={'about'}/>
                                <span>{localization.about}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__contact">
                            <NavLink to="/contact" activeClassName="active">
                                <Icon name={'contact'}/>
                                <span>{localization.contact}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__downloads">
                            <a onClick={this.openDownloadsModal} style={{cursor: "pointer"}}>
                                <Icon name={'download'}/>
                                <span>{localization.downloads}</span>
                            </a>
                        </Box>
                         <Box className="menu__projects local-project">
                            <NavLink to={"/local-projects"} activeClassName="active">
                                <Icon name={'local-project'}/>
                                <span>{localization.localProjects}</span>
                            </NavLink>
                        </Box>
                    </Flex>
                </SidebarMain>
                <SidebarMain lang={selectedLanguage} className={'sidebar-main sidebar--desktop'}>
                    <Logo>
                        <NavLink to="/" className="logo-name">
                            <img src={images.appLogo} alt=""/>
                        </NavLink>
                    </Logo>
                    <Flex className="menu">
                        <Box className="menu__dashboard">
                            <NavLink exact to="" activeClassName="active">
                                <Icon name={'dashboard'}/>
                                <span>{localization.dashboard}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__projects">
                            <NavLink to={"/projects"} activeClassName="active">
                                <Icon name={'projects'}/>
                                <span>{localization.projects}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__about">
                            <NavLink to="/about" activeClassName="active">
                                <Icon name={'about'}/>
                                <span>{localization.about}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__contact">
                            <NavLink to="/contact" activeClassName="active">
                                <Icon name={'contact'}/>
                                <span>{localization.contact}</span>
                            </NavLink>
                        </Box>
                        <Box className="menu__downloads">
                            <a onClick={this.openDownloadsModal} style={{cursor: "pointer"}}>
                                <Icon name={'download'}/>
                                <span>{localization.downloads}</span>
                            </a>
                        </Box>
                        {municipality === 'melamchi' && 
                         <Box className="menu__projects local-project">
                            <NavLink to={"/local-projects"} activeClassName="active">
                                <Icon name={'local-project'}/>
                                <span className="w-88">{localization.localProjects}</span>
                            </NavLink>
                        </Box>
                        }
                        <Box className="menu__switch">
                            <div className="localization-switch">
            <span
                className={selectedLanguage === "en" ? "active" : ""}
                onClick={() => {
                    this.props.dispatchLanguage("en")
                }}
            >
              en
            </span>
                                <span
                                    className={selectedLanguage === "np" ? "active" : ""}
                                    onClick={() => {
                                        this.props.dispatchLanguage("np")
                                    }}
                                >
              ने
            </span>
                            </div>
                        </Box>
                        <Box onClick={this.handleTheme}
                             className={'theme__switch flex cursor-pointer gap-2 items-center justify-center flex-col'}>
                        <span className={'text-white block text-center'}>
                        {this.state.darkTheme ? (selectedLanguage === 'np' ? ' अँध्यारो मोड' : 'Dark Mode') : (selectedLanguage === 'np' ? 'उज्यालो मोड' : 'Light Mode')}
                            </span>
                            <div
                                className={'theme-toggle relative'}>
                        <span className={'theme-toggle-el flex items-center justify-center'}>
                            <Icon name={'theme-toggler'}/>
                        </span>
                            </div>
                        </Box>
                    </Flex>
                    <div className="menu__help">
                        <div className="help-title flex items-center justify-center">
                            <Text.span className="help-text__icon"><img className="help-icon" height={18} width={18} src={images.icons.help} alt="help" /></Text.span>
                            <Text.span>Help</Text.span>
                        </div>
                        <div className="help-content">
                            <span className="caret"/>
                            <ul className="links">
                                <li onClick={() => this.setSelectedHelp("glossary")}>
                                    <span>{localization.glossary}</span>
                                </li>
                                <li onClick={() => this.setSelectedHelp("howto")}>
                                    <span>{localization.howToUse}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </SidebarMain>
            </div>
        )
    }
}

const SidebarMain = styled.div`
  font-size: ${props => (props.lang === "en" ? "14px" : "12px")};
  left: 0;
  bottom: 0;
  z-index: 8;
  position: relative;
  background: var(--color-sidebar-bg);

  ${media.tablet`
    box-shadow: 0 2px 4px 0 ${props => props.theme.primary.dark};
    height: 100vh;
    top: 0;
    position: fixed;
  `};
  .menu {
    border-top: 1px solid ${props => props.theme.dark.charcoalGrey};
    left:0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    z-index: 1;
    position: fixed;
    width: 100vw;
    ${media.tablet`
      flex-direction: column;
      position: static;
      width: auto;
      `} > div {
      border-right: 1px solid ${props => props.theme.dark.charcoalGrey};
      width: 25%;
      bottom: auto;
      top: 0;
      ${media.tablet`border-bottom: 1px solid ${props =>
    props.theme.dark.charcoalGrey};
        border-right: 0;`};
      width: 100%;
      a {
        color: ${props => props.theme.primary.white};
        display: block;
        font-size: ${props => (props.lang === "en" ? "11px" : "14px")};
        opacity: 0.3;
        padding: 8px 0;
        position: relative;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        transition: opacity 0.3s ease-in-out;
        
      svg{
         width: 30px;
         height: 30px;
       }
       @media (min-height: 620px) {
         svg{
                 width: 32px;
                 height: 32px;
               }
        }
        
        &:hover {
          opacity: 1;
        }
        &:before {
          background-color: ${props => props.theme.primary.pissYellow};
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          box-shadow: 0 2px 4px 0 #0e1724;
          content: "";
          height: 100%;
          opacity: 0;
          left: 0;
          position: absolute;
          bottom: 0;
          transition: all 0.5s ease-in-out;
          width: 100%;
          z-index: -1;
          ${media.tablet`
            width:88px;
            border-radius: 0;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;`};
        }
        span {
          color: ${props => props.theme.primary.white};
          position: relative;
          margin-top: 6px;
          display: block;
        }
        &.active {
          opacity: 1;
          color: #252E3B;
          &:before {
            opacity: 1;
          }
          span {
            color: #252E3B;
          }
        }
      }
    }
  }

  @media (min-height: 620px) {
    div.local-project a svg {
      height: 34px;
    }
  }

  .menu__ {
  
    &help {
      position: absolute;
      left: 50%;
      top: 6px;
      transform: translateX(-50%);
      z-index: 1;
      ${media.tablet`position: relative`};

      .help-title {
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;

        span {
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            margin-right: 5px;
          }

          &:last-child {
            color: ${props => props.theme.primary.white};
            opacity: 0.3;
            font-weight: 600;
            transition: opacity 0.2s ease-in;
          }
        }
      }

      .help-content {
        display: block;
        position: absolute;
        top: ${municipality === 'melamchi' ? '-90px' : '85%'};
        left: 4px;
        padding-top: 6px;
        opacity: 0;
        visibility: hidden;
        z-index: 99999999;
        transition: all 0.15s ease-in-out;

        .caret {
          height: 0px;
          width: 0px;
          position: absolute;
          top: ${municipality === 'melamchi' ? '86px' : '0'};
          left: ${municipality === 'melamchi' ? '14px' : '11px'};
          border-width: 0px 8px 8px;
          rotate: ${municipality === 'melamchi' ? '180deg' : ''};
          border-color: transparent transparent
            ${props => props.theme.dark.charcoalGrey};
          border-style: solid;
        }

        .links {
          display: block;
          min-width: 150px;
          font-size: 12px;
          line-height: 16px;
          font-weight: 300;
          letter-spacing: 0.5px;
          color: rgb(255, 255, 255);
          box-shadow: rgba(0, 0, 0, 0.7) 0px 2px 25px -5px;
          background: ${props => props.theme.dark.charcoalGrey};
          border-radius: 4px;
          padding: 8px;

          > li {
            &:not(:last-child) {
              border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }

            a,
            span {
              cursor: pointer;
              display: block;
              padding: 8px 12px;
              color: ${props => props.theme.primary.white};
              font-size: ${props => (props.lang === "en" ? "13px" : "15px")};
              opacity: 0.7;
              text-decoration: none;
              transition: opacity 0.2s ease-in;
              &:hover,
              &.active {
                opacity: 1;
              }
            }
          }
        }
      }

      &:hover {
        .help-content {
          visibility: visible;
          opacity: 1;
        }

        .help-title span:last-child {
          opacity: 1;
        }
      }
    }

    &switch {
      position: absolute;
      top: 6px;
      right: 0;
      ${media.tablet`position: static`};
    }
  }
  .localization-switch {
    background-color: ${props => props.theme.dark.slateGrey};
    border-radius: 11px;
    font-size: 10px;
    line-height: 22px;
    text-align: center;
    margin: 0 16px;
    text-transform: uppercase;
    span {
      background-color: ${props => props.lang};
      color: #0e1724;
      cursor: pointer;
      display: inline-block;
      font-weight: ${props => props.theme.fontWeight.bold};
      opacity: 0.5;
      padding: 0 5px;
      width: 24px;
      font-size: 11px;
      
      &.active {
        background-color: #92969d;
        color: #252E3B;
        opacity: 1;
      }
      &:first-child {
        border-top-left-radius: 11px;
        border-bottom-left-radius: 11px;
      }
      &:last-child {
        border-top-right-radius: 11px;
        border-bottom-right-radius: 11px;
      }
    }
  }
`

const Logo = styled.div`
  .logo-name {
    color: ${props => props.theme.primary.white};
    display: block;
    font-size: 20px;
    font-weight: 700;
    padding: 30px 22px 0;
    text-decoration: none;
    img {
      vertical-align: middle;
    }
    ${media.tablet`padding-bottom: 22px;`};
  }
`

const mapStateToProps = state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage,
    fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
})
const mapDispatchToProps = dispatch => ({
    dispatchLanguage: language => {
        dispatch(setLanguage(language))
    },
})
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/layouts/sidebar/sidebar.js